import { Typography } from '@mui/material';
import React from 'react';
import OwnerNotifications from '../../components/Notifications/OwnerNotifications';

const OwnerNotificationsPage = () => {
    return (
        <>
            <Typography variant='h1'>Notification Preferences</Typography>
            <OwnerNotifications />
        </>
    );
};

export default OwnerNotificationsPage;
